import { call, put, takeEvery } from 'redux-saga/effects';
import moment from 'moment';

import DateFormatter from 'utils/date/DateFormatter';

import {
    DELETE_BP_ENTRY,
    DELETING_BP_ENTRY,
    DELETING_BP_FAIL,
    DELETING_BP_SUCCESS,
    FETCH_52_WEEKS_BP,
    FETCH_52_WEEKS_BP_FAIL,
    FETCH_52_WEEKS_BP_FETCHING,
    FETCH_52_WEEKS_BP_SUCCESS,
    FETCH_DAY_BP,
    FETCH_DAY_BP_FAIL,
    FETCH_DAY_BP_FETCHING,
    FETCH_DAY_BP_SUCCESS,
    FETCH_MULTIPLE_DAYS_BP,
    FETCH_MULTIPLE_DAYS_BP_FAIL,
    FETCH_MULTIPLE_DAYS_BP_FETCHING,
    FETCH_MULTIPLE_DAYS_BP_SUCCESS,
    ADD_BPM,
    ADD_BPM_FAIL,
    ADD_BPM_START,
    ADD_BPM_SUCCESS,
    FETCH_LATEST_BP,
    FETCH_LATEST_BP_FAIL,
    FETCH_LATEST_BP_FETCHING,
    FETCH_LATEST_BP_SUCCESS,
    UPDATE_BPM_NOTE,
    UPDATE_BPM_NOTE_START,
    UPDATE_BPM_NOTE_SUCCESS,
    UPDATE_BPM_NOTE_FAIL
} from 'actions/bloodPressureActions';
import { gcApi } from '../config/axios';

export function* fetchDayBPSaga(action) {
    try {
        yield put({
            type: FETCH_DAY_BP_FETCHING
        });

        const response = yield call(gcApi.get, `/bloodpressure-service/bloodpressure/dayview/${action.date}`);

        yield put({
            type: FETCH_DAY_BP_SUCCESS,
            data: response.data,
            date: action.date
        });
    } catch (e) {
        yield put({
            type: FETCH_DAY_BP_FAIL,
            data: {}
        });
    }
}

export function* deleteBPSaga(action) {
    try {
        yield put({
            type: DELETING_BP_ENTRY
        });

        const bloodPressure = action.bloodPressure;
        const calendarDate = moment(bloodPressure.measurementTimestampLocal).format(DateFormatter.LINK_FORMAT);
        const response = yield call(
            gcApi.delete,
            `bloodpressure-service/bloodpressure/${calendarDate}/${bloodPressure.version}`
        );

        yield put({
            type: DELETING_BP_SUCCESS,
            data: response.data
        });
        //fetch the latest data used in the help modal after delete
        if (action.fetchLatestData && action.fetchLatestData.type) {
            yield put(action.fetchLatestData);
        }
    } catch (e) {
        yield put({
            type: DELETING_BP_FAIL,
            data: {}
        });
    }
}

export function* fetchRangeBPSaga(action) {
    try {
        yield put({
            type: FETCH_MULTIPLE_DAYS_BP_FETCHING,
            dateRange: action.dateRange
        });

        const response = yield call(
            gcApi.get,
            `/bloodpressure-service/bloodpressure/range/${action.dates.startDate}/${
                action.dates.endDate
            }?includeAll=true`
        );

        yield put({
            type: FETCH_MULTIPLE_DAYS_BP_SUCCESS,
            data: response.data,
            date: action.dates.endDate,
            dateRange: action.dateRange
        });
    } catch (e) {
        yield put({
            type: FETCH_MULTIPLE_DAYS_BP_FAIL,
            data: {}
        });
    }
}

export function* fetchFiftyTwoWeeksBPSaga(action) {
    try {
        yield put({
            type: FETCH_52_WEEKS_BP_FETCHING
        });

        const response = yield call(
            gcApi.get,
            `/bloodpressure-service/bloodpressure/weeklyRange/${action.dates.startDate}/${action.dates.endDate}`
        );

        yield put({
            type: FETCH_52_WEEKS_BP_SUCCESS,
            data: response.data,
            date: action.dates.endDate
        });
    } catch (e) {
        yield put({
            type: FETCH_52_WEEKS_BP_FAIL,
            data: {},
            date: action.dates.endDate
        });
    }
}

export function* addBPM(action) {
    try {
        yield put({
            type: ADD_BPM_START
        });

        let url = `/bloodpressure-service/bloodpressure`;
        const response = yield call(gcApi.post, url, {
            ...action.payload
        });

        //after updateing the measurements fetch the new values
        if (action.actionToDispatch && action.actionToDispatch.type) {
            yield put(action.actionToDispatch);
        }

        yield put({
            type: ADD_BPM_SUCCESS,
            response
        });

        if (action.saveBPM) {
            action.saveBPM();
        }

        if (action.fetchData) {
            action.fetchData();
        }
        //fetch the latest data used in the help modal
        if (action.fetchLatestData && action.fetchLatestData.type) {
            yield put(action.fetchLatestData);
        }
    } catch (e) {
        yield put({
            type: ADD_BPM_FAIL,
            data: {}
        });
    }
}

export function* fetchLatestBPSaga(action) {
    try {
        yield put({
            type: FETCH_LATEST_BP_FETCHING
        });
        const response = yield call(
            gcApi.get,
            `/bloodpressure-service/bloodpressure/daily/last/${action.date.startDate}/${action.date.endDate}`
        );

        yield put({
            type: FETCH_LATEST_BP_SUCCESS,
            endDate: action.date.endDate,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_LATEST_BP_FAIL,
            data: {}
        });
    }
}

export function* updateBPMNote(action) {
    try {
        yield put({
            type: UPDATE_BPM_NOTE_START
        });

        const response = yield call(gcApi.put, '/bloodpressure-service/bloodpressure', {
            ...action.payload
        });

        yield put({
            type: UPDATE_BPM_NOTE_SUCCESS,
            response
        });

        if (action.fetchBPData && action.fetchBPData.type) {
            yield put(action.fetchBPData);
        }
    } catch (e) {
        yield put({
            type: UPDATE_BPM_NOTE_FAIL,
            data: {}
        });
    }
}

export const bloodPressureSagas = [
    takeEvery(FETCH_DAY_BP, fetchDayBPSaga),
    takeEvery(FETCH_MULTIPLE_DAYS_BP, fetchRangeBPSaga),
    takeEvery(FETCH_52_WEEKS_BP, fetchFiftyTwoWeeksBPSaga),
    takeEvery(DELETE_BP_ENTRY, deleteBPSaga),
    takeEvery(ADD_BPM, addBPM),
    takeEvery(FETCH_LATEST_BP, fetchLatestBPSaga),
    takeEvery(UPDATE_BPM_NOTE, updateBPMNote)
];
